import { z } from 'zod';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
export var UserRole;
(function (UserRole) {
    UserRole["GUEST"] = "GUEST";
    UserRole["USER"] = "USER";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
})(UserRole || (UserRole = {}));
export var UserPermissionScope;
(function (UserPermissionScope) {
    UserPermissionScope["READONLY"] = "READONLY";
})(UserPermissionScope || (UserPermissionScope = {}));
export const CurrentMultiUserProfile = z.object({
    id: z.string().uuid(),
    username: z.string().refine(isEmail, { message: 'Has to be an email' }),
    data: z.object({
        profile: z.object({
            firstName: z.string().optional(),
            lastName: z.string().optional(),
            phoneNumber: z.string().refine(isMobilePhone, { message: 'Has to be a phone number' })
                .or(z.literal(''))
                .optional(),
            icon: z.string().url().optional(),
        }).strict().optional(),
        meta: z.object({
            [z.string()]: z.any(),
        }).optional(),
    }).strict(),
}).strict();
export const CreateUserWithMultData = z.object({
    role: z.nativeEnum(UserRole),
    email: z.string().refine(isEmail, { message: 'Has to be an email' }),
    disableAt: z.string().datetime()
        .refine((value) => new Date(value) > new Date(), { message: 'Has to be in the future' })
        .optional(),
    creatorUsername: z.string().refine(isEmail, { message: 'Has to be an email' }).optional(),
    permissions: z.object({
        scope: z.nativeEnum(UserPermissionScope).array().optional(),
    }).optional(),
    type: z.string().optional(),
    redirectUrl: z.string().optional(),
});
//# sourceMappingURL=schemas.js.map